import { Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import LabeledList from '~/components/LabeledList';

export default function LoadingModels() {
    return (
        <LabeledList label="Model">
            <Box display="flex" gap={1} justifyContent="center" width="100%">
                <Box>
                    <CircularProgress size={12} />
                </Box>
                <Typography variant="body2">
                    <FormattedMessage id="loadingModels" />
                    ...
                </Typography>
            </Box>
        </LabeledList>
    );
}
